import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

function loadView(view: string) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
  mode: "hash",
  // TODO: 本番時は下に変更
  base: "/okinawahealthaction",
  // base: process.env.BASE_URL,
  routes: [
    {
      // path: "/",
      path: "/index.html",
      name: "top",
      component: loadView("Top")
    },
    {
      path: "/okinawa-data",
      name: "OkinawaData",
      component: loadView("OkinawaData")
    },
    {
      path: "/lifestyle-habit",
      name: "LifestyleHabit",
      component: loadView("LifestyleHabit")
    },
    {
      path: "/meal-improvement",
      name: "MealImprovement",
      component: loadView("MealImprovement")
    },
    {
      path: "/performance-report",
      name: "PerformanceReport",
      component: loadView("PerformanceReport")
    },
    {
      path: "/working-womens-health",
      name: "WorkingWomensHealth",
      component: loadView("WorkingWomensHealth")
    },
    {
      path: "/report-jta",
      name: "Report-JTA",
      component: loadView("Report-JTA")
    },
    {
      path: "/report-kounan",
      name: "Report-Kounan",
      component: loadView("Report-Kounan")
    },
    {
      path: "/report-okinawasaiken",
      name: "Report-Okinawasaiken",
      component: loadView("Report-Okinawasaiken")
    },
    {
      path: "/report-misaki",
      name: "Report-Misaki",
      component: loadView("Report-Misaki")
    },
    {
      path: "/report-egaonohana",
      name: "Report-Egaonohana",
      component: loadView("Report-Egaonohana")
    },
    {
      path: "/report-shining",
      name: "Report-Shining",
      component: loadView("Report-Shining")
    },
    {
      path: "/support-organize-information",
      name: "SupportOrganizeInformation",
      component: loadView("SupportOrganizeInformation")
    },
    {
      path: "/smoking-at-work",
      name: "SmokingAtWork",
      component: loadView("SmokingAtWork")
    },
    {
      path: "/stress-at-work",
      name: "StressAtWork",
      component: loadView("StressAtWork")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
